import React, { useCallback, useEffect } from 'react';

import { DeveloperBannerManager } from '../dev-banner';

import { SIDEBAR_CONTENT_ID } from './ClientSidebar';
import { ClientSidebarManager, CollapsedWidth, ExpandedWidth } from './ClientSidebarManager';

function useClientDrawer(options?: { key?: string; expanded?: boolean }) {
  const [expanded, setExpanded] = React.useState<boolean>(options?.expanded ?? false);
  const expandedWidth = '300px';
  const collapsedWidth = '0';

  const key = options?.key ?? 'default';

  useEffect(() => {
    DeveloperBannerManager.getInstance().setBanner({
      level: 'warning',
      message: 'useClientDrawer() called, please migrate to ClientSidebar.useSidebar()',
    });
  }, []);

  React.useEffect(() => {
    ClientSidebarManager.getInstance().init(key, { expanded: options?.expanded, expandedWidth, collapsedWidth });
    ClientSidebarManager.getInstance().subscribe(listener);

    return () => {
      ClientSidebarManager.getInstance().unsubscribe(listener);
    };
  }, [key, options?.expanded, expandedWidth, collapsedWidth]);

  const listener = (state: [expanded: boolean, expandedWidth: ExpandedWidth, collapsedWidth: CollapsedWidth]) => {
    // not overwriting collapsedWidth because it should not change for this instance
    const [expanded] = state;
    setExpanded(expanded);
  };

  const openDrawer = useCallback(() => {
    ClientSidebarManager.getInstance().setExpanded(true);
  }, []);

  const closeDrawer = useCallback(() => {
    ClientSidebarManager.getInstance().setExpanded(false);
  }, []);

  const toggleDrawer = useCallback(() => {
    ClientSidebarManager.getInstance().toggleExpanded();
  }, []);

  return {
    expanded,
    openDrawer,
    closeDrawer,
    toggleDrawer,
  };
}

/**
 * @deprecated Use ClientSidebar instead.
 */
export const ClientDrawer = {
  /**
   * @deprecated Use ClientSidebar.useSidebar() instead.
   */
  useClientDrawer,
  sidebarContentId: SIDEBAR_CONTENT_ID,
};
